import type { InjectionKey } from 'vue';
import { provideLocal, injectLocal } from '@vueuse/core';

const STICKY_ATB_CONTEXT_ENABLED: InjectionKey<{ isStickyAtbContextEnabled: boolean }> = Symbol('STICKY_ATB_CONTEXT_ENABLED');

/**
 * @description Injects the STICKY_ATB_CONTEXT_ENABLED token with a value of true.
 */
export function useStickyAtbContextEnabledProvide() {
  provideLocal(STICKY_ATB_CONTEXT_ENABLED, { isStickyAtbContextEnabled: true });
}

/**
 * @description Retrieves whether the sticky ATB context is currently enabled in the nearest ancestor.
 * @returns  {object} { isStickyAtbContextEnabled: boolean } True if sticky ATB state is enabled, false otherwise.
 */
export function useStickyAtbContextEnabled() {
  return injectLocal(STICKY_ATB_CONTEXT_ENABLED, () => ({ isStickyAtbContextEnabled: false }), true);
}
